export default {
  control: (styles) => ({
    ...styles,
    height: "32px",
    minHeight: "32px",
    width: "220px",
    border: "none",
  }),
  valueContainer: (styles) => ({
    ...styles,
    flexWrap: "nowrap",
    overflow: "auto hidden",
  }),
  multiValue: (styles) => ({
    ...styles,
    minWidth: "auto",
  }),
};
